import {
  RANDOM_IMG, BEERS, FOOD_TAPAS, ALBAICIN, FLAMENCO, GRANADA_SAYING, GRANADA_LOCATION_INFO,
  GRANADA_INTRO, GRANADA_CUISINE_INFO, ALHAMBRA_INFO, ALBAICIN_INTRO, ALBAICIN_VIEWING, ALBAICIN_CARMENES, PATIOS_INTRO, LUCIA_PIC, FERNANDO_PIC,
  FOOD_TAPAS_MAIN, BEDROOM_MAIN, FLAMENCO_REVEAL, ALBAICIN_MAIN, ABOUT_US_MAIN, PATIO_MAIN, GALLERY_MAIN
} from './constants';

const TILEDATA = {
  home: [
    {
      imgUrl: GALLERY_MAIN,
      description: 'home.galleryTile.description',
      title: 'home.galleryTile.title',
      size: 'half',
      reveal: false,
      revealText: 'Update text to have some meaning'
    },
    {
      imgUrl: RANDOM_IMG,
      description: 'Ssowdpowdwdwq d  oiw iqdhwqoiddhwqoihwqofo hwqfhwqfwqhfwqhf wqhf wqfwqhof wqf',
      title: 'FORM',
      size: 'half',
      reveal: true,
      // revealText: 'Update text to have some meaning'
    },
    // Wellcome
    {
      imgUrl: 'http://doesnt.exist',
      description: '',
      title: 'home.welcomeTile.title',
      size: 'half',
      reveal: true,
      revealText: 'home.welcomeTile.revealText',
    },
    // Rooms 
    {
      imgUrl: BEDROOM_MAIN,
      description: 'home.roomsTile.description',
      title: 'home.roomsTile.title',
      size: 'half',
      reveal: false
    },
    // Granada & albaicin 
    {
      imgUrl: ALBAICIN_MAIN,
      description: 'home.granadaAlbaicinTile.description',
      title: 'home.granadaAlbaicinTile.title',
      size: 'full',
      reveal: false,
      revealText: 'Update text to have some meaning'
    },
    // Beers tile
    // {
    //   imgUrl: BEERS,
    //   description: 'Ssowdpowdwdwq d  oiw iqdhwqoiddhwqoihwqofo hwqfhwqfwqhfwqhf wqhf wqfwqhof wqf',
    //   title: 'BEERS',
    //   size: 'half',
    //   reveal: true,
    //   revealText: 'Update text to have some meaning'
    // },
    // Patios tile
    {
      description: PATIOS_INTRO,
      title: 'Patios',
    },
    {
      imgUrl: PATIO_MAIN,
      description: 'home.patiosTile.description',
      title: 'home.patiosTile.title',
      reveal: true,
      revealText: 'home.patiosTile.revealText'
    },

    // flamenco
    {
      imgUrl: FLAMENCO,
      description: 'home.flamencoTile.description',
      title: 'home.flamencoTile.title',
      size: 'half',
      reveal: true,
      revealText: 'home.flamencoTile.revealText'
    },
    // About us tile 
    {
      imgUrl: ABOUT_US_MAIN,
      description: 'home.aboutUsTile.description',
      title: 'home.aboutUsTile.title',
      size: 'half',
      reveal: false,
      revealText: 'Update text to have some meaning'
    },
    // Tapas tile
    {
      imgUrl: FOOD_TAPAS_MAIN,
      description: '',
      title: 'home.foodTile.title',
      size: 'half',
      reveal: true,
      revealText: 'home.foodTile.revealText'
    },
    // services and facilites 
    {
      imgUrl: RANDOM_IMG,
      description: 'Ssowdpowdwdwq d  oiw iqdhwqoiddhwqoihwqofo hwqfhwqfwqhfwqhf wqhf wqfwqhof wqf',
      title: 'SERVICES & FACILITIES',
      size: 'full',
      reveal: true,
      revealText: 'Update text to have some meaning'
    },
    {
      imgUrl: RANDOM_IMG,
      description: 'Ssowdpowdwdwq d  oiw iqdhwqoiddhwqoihwqofo hwqfhwqfwqhfwqhf wqhf wqfwqhof wqf',
      title: 'LOCATION',
      size: 'full',
      reveal: false
    },
    {
      imgUrl: RANDOM_IMG,
      description: 'Ssowdpowdwdwq d  oiw iqdhwqoiddhwqoihwqofo hwqfhwqfwqhfwqhf wqhf wqfwqhof wqf',
      title: 'ADDRESS',
      size: 'half',
      reveal: false
    },
    {
      imgUrl: 'https://firebasestorage.googleapis.com/v0/b/oripando-e7e2d.appspot.com/o/mains%2FDigitalNomads.jpg?alt=media&token=5f4a5dfb-b864-4a33-8934-0bc265f12517',
      description: 'home.news.description',
      title: 'home.news.title',
      size: 'half',
      reveal: true,
      revealText: 'home.news.revealText',
    },
  ],
  bedrooms: [
    {
      imgUrl: BEDROOM_MAIN,
      description: '',
      title: 'bedrooms.mainTile.title',
    },
    {
      description:
        'bedrooms.generalInoTile.description',
      title: 'bedrooms.generalInoTile.title',
    },
    {
      imgUrl: 'https://firebasestorage.googleapis.com/v0/b/oripando-e7e2d.appspot.com/o/images%2Fweb%20pros%2Fnest_2.jpg?alt=media&token=16e3dbe4-28b8-40f3-910e-89fe66670f9a',
      description: '',
      title: '',
    },
    {
      imgUrl: "https://firebasestorage.googleapis.com/v0/b/oripando-e7e2d.appspot.com/o/images%2Fweb%20pros%2Famazonas_5.jpg?alt=media&token=53cc6f3d-fa7b-40ca-adc6-a1e970bf99fe",
      description: '',
      title: '',
    },
    {
      description:
        'bedrooms.sharedInfoTile.description',
      title: 'bedrooms.sharedInfoTile.title',
    },
    {
      description:
        'bedrooms.privateInfoTile.description',
      title: 'bedrooms.privateInfoTile.title',
    },
    {
      imgUrl: 'https://firebasestorage.googleapis.com/v0/b/oripando-e7e2d.appspot.com/o/images%2Fweb%20pros%2Fcave_2.jpg?alt=media&token=fccb8ee8-65ee-4f23-a6c5-a3d420d0374d',
      description: '',
      title: '',
    },
    {
      imgUrl: 'https://firebasestorage.googleapis.com/v0/b/oripando-e7e2d.appspot.com/o/images%2Fapartment-1.jpg?alt=media&token=76a3548c-e02b-4fb4-8873-70382e056973',
      description: '',
      title: '',
    },
    {
      description:
        'bedrooms.apartmentInfoTile.description',
      title: 'bedrooms.apartmentInfoTile.title',
    },
  ],
  granada: [
    {
      imgUrl: ALBAICIN_MAIN,
      description: '',
      title: 'granada.mainTile.title',
    },
    {
      description: 'granada.granadaInfoTile.description',
      title: 'granada.granadaInfoTile.title',
    },
    {
      imgUrl: 'https://static2.ideal.es/www/multimedia/201803/14/media/cortadas/granada-votacion-kqJB-U501281817030AGC-624x385@Ideal.jpg',
      description: '',
      title: '',
    },
    {
      imgUrl: 'https://s2.eestatic.com/2020/01/25/viajes/Viajes-Granada_-Municipio-Viajes_462465595_143369070_1706x960.jpg',
      description: '',
      title: '',
    },
    {
      description: 'granada.alhambraInfoTile.description',
      title: 'granada.alhambraInfoTile.title',
    },
    // {
    //   description: GRANADA_LOCATION_INFO,
    //   title: 'Location & Weather',
    // },
    {
      description: 'granada.tapasInfoTile.description',
      title: 'granada.tapasInfoTile.title',
    },
    {
      imgUrl: 'http://www.turgranada.es/wp-content/uploads/sites/2/2014/05/tapas0.jpg?x53512',
      description: '',
      title: '',
    },
    {
      imgUrl: 'https://static.ideal.es/www/multimedia/201904/02/media/panoramica-OK.jpg',
      description: '',
      title: '',
    },
    {
      description: 'granada.locationInfoTile.description',
      title: 'granada.locationInfoTile.title',
    },
    //News 14
    {
      imgUrl: GALLERY_MAIN,
      description: 'home.galleryTile.description',
      title: 'home.galleryTile.title',
      size: 'half',
      reveal: false,
      revealText: 'Update text to have some meaning'
    }
  ],
  albaicin: [
    // Main tile
    {
      imgUrl: 'http://www.turgranada.es/wp-content/blogs.dir/2/files_mf/cache/th_8e735c5fb9f20d17096a998987c257d7_albaicin0a.jpg?x53512',
      description: '',
      title: 'granada.mainAlbaicinTile.title',
    },
    // Introduction 
    {
      description: 'granada.albaicinInfoTile.description',
      title: 'granada.albaicinInfoTile.title',
    },
    {
      imgUrl: 'https://www.lookoutpro.com/wp-content/uploads/2019/03/vistas-del-Albaicin-granada.jpg',
      description: '',
      title: '',
    },
    // Viewing points
    {
      imgUrl: 'https://granadasmile.com/wp-content/uploads/2017/10/Mirador-de-San-Nicola%CC%81s.jpg',
      description: '',
      title: '',
    },
    {
      description: 'granada.viewPointsInfoTile.description',
      title: 'granada.viewPointsInfoTile.title',
    },
    // Carmenes
    {
      description: 'granada.carmenesInfoTile.description',
      title: 'granada.carmenesInfoTile.title',
    },
    {
      imgUrl: 'https://jardinessinfronteras.files.wordpress.com/2018/01/carmen-de-los-chapiteles-k.jpg',
      description: '',
      title: '',
    },
  ],
  about: [
    {
      imgUrl: ABOUT_US_MAIN,
      description: '',
      title: 'about.mainTile.title',
    },
    // Hostel image or cool image 
    {
      description:
        'about.generalInfoTile.description',
      title: 'about.generalInfoTile.title',
    },
    // Hostel image or cool image 
    {
      imgUrl: "https://firebasestorage.googleapis.com/v0/b/oripando-e7e2d.appspot.com/o/images%2Fweb%20pros%2FpatioInt_2.jpg?alt=media&token=ef136d72-fc53-4bed-9016-e756293aa872",
      description: '',
      title: '',
    },
    // Lucias picture 
    {
      imgUrl: LUCIA_PIC,
      description: '',
      title: '',
    },
    // Lcia's description
    {
      description:
        'about.luciaInfoTile.description',
      title: 'about.luciaInfoTile.title',
    },
    // Fernando's description 
    {
      description:
        'about.fernadoInfoTile.description',
      title: 'about.fernadoInfoTile.title',
    },
    // Fernando's picture
    {
      imgUrl: FERNANDO_PIC,
      description: '',
      title: '',
    }
  ],
  contact: [
    {
      imgUrl: "https://firebasestorage.googleapis.com/v0/b/oripando-e7e2d.appspot.com/o/mains%2FcontactUs.jpg?alt=media&token=c968f08d-2099-40de-bbde-3037f26d55d6",
      description: '',
      title: "contact.mainTile.description",
    },
  ],
  gallery: [
    {
      imgUrl: GALLERY_MAIN,
      description: '',
      title: "gallery.mainTile.description",
    }
  ],
  downloads: [
    {
      imgUrl: RANDOM_IMG,
      description: 'downloads.internalRules.description',
      title: "downloads.internalRules.title",
    },
    {
      imgUrl: RANDOM_IMG,
      description: 'downloads.internalRules.description',
      title: "downloads.ourServices.title",
    }

  ]
};

export default TILEDATA;



// WEBPACK FOOTER //
// ./src/common/tileData.js